<template>
  <ul class="menu-nav">
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-rel menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{
        'menu-item-active': hasActiveChildren('/backend/students'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text"> Users </span>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-left">
        <ul class="menu-subnav">
          <router-link
            to="/backend/students"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> List All Users </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/students/create"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Add new User </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/teams"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Teams </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/roles"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Roles </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/Levels"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage User Levels </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/profiles"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage User Profiles </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-rel menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{
        'menu-item-active': hasActiveChildren('/backend/projects'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text"> Content </span>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-left">
        <ul class="menu-subnav">
          <router-link
            to="/backend/projects"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> List All Projects </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/projects/create"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Add new Project </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/paths"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Paths </span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/backend/outcomes"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Outcomes </span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/backend/tags"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Tags </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/challenges"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Challenges </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/backend/deadlines"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Deadlines </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-rel menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{
        'menu-item-active': hasActiveChildren('/backend/instances'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text"> Evolution </span>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-left">
        <ul class="menu-subnav">
          <router-link
            to="/backend/instances"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Instances </span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/backend/sessions"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Sessions </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-rel menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{
        'menu-item-active': hasActiveChildren('/backend/reports'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text"> Reports </span>
      </a>
      <div class="menu-submenu menu-submenu-classic menu-submenu-left">
        <ul class="menu-subnav">
          <router-link
            to="/backend/instances"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Instances </span>
              </a>
            </li>
          </router-link>

          <router-link
            to="/backend/sessions"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Manage Sessions </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      class="menu-item menu-item-rel menu-item-submenu menu-item-open-dropdown"
    >
      <a href="#" v-on:click="calculatePoints()" class="menu-link menu-toggle">
        <span class="menu-text"> Calculate Points </span>
      </a>
    </li>
  </ul>
</template>

<script>
import axios from "axios";

export default {
  name: "KTMenu",
  data() {
    return {};
  },
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    instances() {
      return this.$store.getters.getInstances;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    sessions() {
      return this.$store.getters.getSessions;
    },
    challenges() {
      return this.$store.getters.getChallenges;
    },
  },
  beforeMount() {
    // axios
    //   .get("users?fields=points.profiles.profile, instances-project,sessions")
    //   .then(response => {
    //     this.users = response.data;
    //     console.log("Usuaris", this.users);
    //   });
  },

  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    calculatePoints() {
      this.users.forEach((user) => {
        let puntsInstancies = [];
        this.profiles.forEach(function(e) {
          puntsInstancies.push({ points: 0, profile: e._id });
        });
        console.log("intacies", user.userName, user.instances);
        if (user.instances.length > 0) {
          user.instances.forEach((instance) => {
            let ins = this.instances.find((i) => i._id == instance);
            console.log(instance, ins, ins.stars);
            if (ins.stars) {
              let estrelles;
              switch (ins.stars) {
                case 1:
                  estrelles = 0.1;
                  break;
                case 2:
                  estrelles = 0.3;
                  break;
                case 3:
                  estrelles = 0.5;
                  break;
                case 4:
                  estrelles = 0.7;
                  break;
                case 5:
                  estrelles = 1;
                  break;
              }

              let project = this.projects.find((p) => p._id == ins.project);
              console.log("proj", project.title, project.points, ins.stars);
              if (project.points.length) {
                let divisor = project.numberOfUsers == 1 ? 1 : ins.users.length;
                project.points.forEach((points) => {
                  puntsInstancies.find(
                    (p) => p.profile == points.profile
                  ).points += (points.points / divisor) * estrelles;
                });
              }
            }
          });
          //console.log("instances", this.users[u].instances[i]);
        }
        console.log("PUNTS Instancies", user.userName, puntsInstancies);
        let total = 0;
        let punts = { assistencia: 0, training: 0, profiles: [] };
        if (user.sessions.length > 0) {
          user.sessions.forEach((session) => {
            let sessionFull = this.sessions.find((s) => s._id == session);
            if (sessionFull) {
              if (sessionFull.points && sessionFull.points.length) {
                sessionFull.points.forEach(function(s) {
                  puntsInstancies.find((p) => p.profile == s.profile).points +=
                    s.points;
                });
              }

              punts.assistencia += sessionFull.assistance ? 100 : 0;
              //punts.training += sessionFull.training ? 200 : 0;
            }
          });
          if (user.challenges.length > 0) {
            user.challenges.forEach((challenge) => {
              this.challenges
                .find((c) => c._id == challenge)
                .points.forEach((point) => {
                  puntsInstancies.find(
                    (p) => p.profile == point.profile
                  ).points += point.points;
                });
              //punts.training += 200;
              // ch.points.forEach(point => {
              //   puntsInstancies.find(p => p.profile == point.profile).points +=
              //     point.points;
              // });
            });
          }

          total += punts.assistencia;
          total += punts.training;
        }
        punts.profiles = puntsInstancies;
        //console.log("PUNTS Instancies + Sessions", user, punts);
        punts.profiles.forEach((e) => {
          total += e.points;
        });
        axios
          .put("users/" + user._id, {
            points: {
              total: total,
              profiles: punts.profiles,
            },
          })
          .then((res) => {
            console.log(res);
            console.log("PUNTS TOTALS", user.userName, total);
          });
      });
    },
  },
};
</script>
